// @flow
import React from 'react';
// eslint-disable-next-line
import styles from "./styles.scss";

export type FooterLinkType = 'big' | 'small';

export type FooterLinkProps = {
  title: string,
  link: string,
  type?: FooterLinkType,
  prefix?: string,
};

export const FooterLink = (props: FooterLinkProps) => {
  const { title, link, type = 'big', prefix } = props;
  const className = type === 'small' ? 'footer-link-small' : 'footer-link';

  return (
    <a href={link} className={className}>
      {prefix ? (
        <>
          {prefix} <strong>{title}</strong>
        </>
      ) : (
        title
      )}
    </a>
  );
};
